'use client';
import { useGSAP } from '@gsap/react';
import { Box, Center, Grid, Text } from '@chakra-ui/react';

import { experienceAnimation } from 'shared/gsap';
import BlockShadow from 'shared/BlockShadow';
import NextImage from 'shared/NextImage';

import { SECTIONS_IDS } from 'constants/global';
import BgView from 'assets/illustrations/experience/bg.webp';
import Headlights from 'assets/illustrations/experience/headlights.svg';

const bgImagesStyles = {
  w: 'full',
  minW: { mobile: '712px', tablet: 'unset' },
  bottom: { mobile: '-30px', tablet: '-29px', laptop: '-56px' },
  left: { mobile: 'calc(50% - (712px / 2))', tablet: '0' },
};

const Experience = () => {
  useGSAP(experienceAnimation);

  return (
    <Center
      as="section"
      id={SECTIONS_IDS.experience}
      w="full"
      h={{ mobile: '488px', tablet: 'clamp(424px, 56vw, 600px)', laptop: '750px' }}
      alignItems="start"
      pos="relative"
      overflow="hidden"
      color="ourWhite"
    >
      <BlockShadow
        position="top"
        h={{ mobile: '212px', tablet: '100px', laptop: '145px' }}
        zIndex="3"
      />

      <Box {...bgImagesStyles} pos="absolute" zIndex="1">
        <NextImage src={BgView} alt="Фоновое изображение" w="full" h="full" />
      </Box>

      <Box {...bgImagesStyles} id="experience-bg-headlights" pos="absolute" zIndex="2" opacity="0">
        <NextImage src={Headlights} alt="Горящие фары" w="full" h="full" />
      </Box>

      <Grid w="full" templateColumns="1fr" templateRows="1fr" zIndex="4">
        <Text
          as="h2"
          id="experience-title"
          gridArea="1 / 1"
          w="full"
          p={{ mobile: '40px 16px 0', tablet: '15px 50px 0', laptop: '25px 80px 0' }}
          textAlign="center"
          textTransform="uppercase"
          zIndex="3"
        >
          Чтобы работать менеджером, нужен опыт
        </Text>

        <Text
          as="h2"
          id="experience-second-title"
          gridArea="1 / 1"
          w="full"
          p={{ mobile: '40px 16px 0', tablet: '0 50px 0', laptop: '25px 80px 0' }}
          textAlign="center"
          textTransform="uppercase"
          opacity="0"
          zIndex="2"
        >
          Чтобы получить опыт — нужно работать менеджером
        </Text>

        <Text
          id="experience-text"
          gridArea="1 / 1"
          w="full"
          p={{ mobile: '40px 16px 0', tablet: '0 50px 0', laptop: '32px 270px 0' }}
          textAlign="center"
          textStyle="h5"
          opacity="0"
          zIndex="1"
        >
          Знания без практики не работают. Навыки рождаются в деле
        </Text>
      </Grid>

      <BlockShadow
        position="bottom"
        h={{ mobile: '86px', tablet: '106px', laptop: '123px' }}
        zIndex="3"
      />
    </Center>
  );
};

export default Experience;
